// extracted by mini-css-extract-plugin
module.exports = {"text_container":"Negociacion__text_container__3ylKi","contenedor_posturas":"Negociacion__contenedor_posturas__3KgPq"};